import { featuredProducts } from '@/mocks/products';

export default function ProductSection() {
  return (
    <section id="produtos" className="relative w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block bg-accent-100 text-accent-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
            Top Picks
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
            Melhores Produtos do{' '}
            <span className="text-accent-500">CSSBuy Spreadsheet</span>
          </h2>
          <p className="text-foreground-600 mt-3 text-sm md:text-base max-w-xl mx-auto">
            Produtos verificados e selecionados das marcas mais procuradas
          </p>
        </div>

        {/* Product Cards Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-product-shop="">
          {featuredProducts.map((product) => (
            <a
              key={product.id}
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-100 rounded-2xl border border-background-200/60 hover:border-accent-200 transition-all duration-300 overflow-hidden cursor-pointer"
            >
              {/* Image Area */}
              <div className="relative w-full aspect-square bg-background-50 overflow-hidden">
                {product.tag && (
                  <span className="absolute top-3 left-3 z-10 bg-primary-500 text-white text-[10px] font-bold px-2.5 py-1 rounded-full">
                    {product.tag}
                  </span>
                )}
                <img
                  src={product.image}
                  alt={`${product.name} - CSSBuy Spreadsheet`}
                  title={`${product.name} - CSSBuy Spreadsheet`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  width={product.imageWidth}
                  height={product.imageHeight}
                />
              </div>
              {/* Info Area */}
              <div className="p-4">
                <p className="text-xs text-foreground-500 font-medium mb-1">{product.brand}</p>
                <p className="text-sm text-foreground-950 font-semibold leading-tight line-clamp-2">{product.name}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}